/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';
const IconLockClosed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconLockClosed"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14 2a3 3 0 0 1 3 3l.002 5.103a7 7 0 1 1-10.002 0V4.999a3 3 0 0 1 3-3zm-2 8a5 5 0 1 0 0 10 5 5 0 0 0 0-10m1 3v4h-2v-4zm1-9h-4a1 1 0 0 0-1 1v3.674A7 7 0 0 1 12 8c1.074 0 2.091.242 3 .674V5a1 1 0 0 0-1-1"
    />
  </svg>
);
export default IconLockClosed;
